var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('div',{staticClass:"disBetween nodataCont"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"nodataText"},[_vm._v(_vm._s(_vm.str))]),_c('div',{staticClass:"line"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }